import { RootState } from '@src/store';
import { IOrderInitialState } from './types';
import { createSelector } from '@reduxjs/toolkit';

const OrderReducer = (state: RootState): IOrderInitialState => state.OrderPageReducer;
const OrderState = createSelector([OrderReducer], (state) => state);

export const selectCollapse = createSelector([OrderState], (state) => state.collapse);
export const selectOrder = createSelector([OrderState], (state) => state.selectedOrder);
export const selectOrderFormData = createSelector([OrderState], (state) => state.orderFormData);
export const selectAssignedDrone = createSelector([OrderState], (state) => state.assignedDrone);
export const selectAssignMethod = createSelector([OrderState], (state) => state.assignMethod);
export const selectMissionId = createSelector([OrderState], (state) => state.missionId);
export const selectSelectedMissionTemplate = createSelector([OrderState], (state) => state.selectedMissionTemplate);